import oneProfileSetup from "./oneProfileSetup";
import { getMe } from "./api/users";
import { ResponseError } from "./types/errors";
import { User, Profile } from "./types/users";
import { Office, LocationInfo } from "./types/location";
import { Assignments } from "./types/assignments";
import NotFound from "./pages/NotFound";
import DownTime from "./pages/DownTime";

const users = { getMe: getMe };
const pages = {
  NotFound: oneProfileSetup(NotFound),
  DownTime: oneProfileSetup(DownTime),
};
const components = {
  DownTime: DownTime,
};

export { oneProfileSetup, users, pages, components };

export type { User, Profile, Office, LocationInfo, Assignments, ResponseError };
